import { useFormContext } from 'react-hook-form';

import { withoutCommas } from 'constants/regex';

import { NumberInputControlled } from 'components/_basic/Form/NumberInput';
import { FocusedFieldAttribute } from 'components/BusinessToolForm/Instructions/InstructionsByAttribute/types';

import { MONTHLY_EXPANSES_FIELD_TYPE, MonthlyExpansesFieldProps } from './type';

export const MonthlyExpansesField: React.FC<MonthlyExpansesFieldProps> = ({
  name,
  watchFiledName,
  label,
  control,
  adornmentType,
  disabled,
  fieldType,
  watchedTableValues,
  totalFirstMonthRevenue
}) => {

  const { setValue } = useFormContext();

  const handleChangeAction = (inputValue: string, type: string) => {
    switch (type) {
      case MONTHLY_EXPANSES_FIELD_TYPE.PERCENT: {
        const value = Number(totalFirstMonthRevenue) * (Number(inputValue) / 100) || '';
        setValue(watchFiledName, value);
        break;
      }
      case MONTHLY_EXPANSES_FIELD_TYPE.AMOUNT: {
        const value = (Number(inputValue) / Number(totalFirstMonthRevenue)) * 100 || '';
        setValue(watchFiledName, value);
        break;
      }
      case MONTHLY_EXPANSES_FIELD_TYPE.GROWTH: {
        if (!watchedTableValues) break;
        const modiFiedTable = watchedTableValues.map((row) => {
          const newRow = { ...row };
          newRow.column1 = inputValue;
          return newRow;
        });
        setValue(watchFiledName, modiFiedTable);
        break;
      }
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const normalizeValue = e.target.value.replace(withoutCommas, '');
    handleChangeAction(normalizeValue, fieldType);
  };

  return (
    <NumberInputControlled
      control={control}
      id={name}
      name={name}
      label={label}
      adornmentType={adornmentType}
      disabled={disabled}
      onChange={handleChange}
      data-mirror-field={FocusedFieldAttribute.monthlyExpenses}
    />
  );
};
